import { render, staticRenderFns } from "./products-inventory-options.vue?vue&type=template&id=c440f344&scoped=true&"
import script from "./products-inventory-options.vue?vue&type=script&lang=js&"
export * from "./products-inventory-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c440f344",
  null
  
)

export default component.exports